const install = function (Vue, options) {
    Vue.prototype.formatDates=function(time){
        var date = new Date(time);
    
        var year = date.getFullYear(),
            month = date.getMonth() + 1,//月份是从0开始的
            day = date.getDate(),
            hour = date.getHours(),
            min = date.getMinutes(),
            sec = date.getSeconds();
            month=month<10?'0'+month:month
            day=day<10?'0'+day:day
            hour=hour<10?'0'+hour:hour
            min=min<10?'0'+min:min
            sec=sec<10?'0'+sec:sec
        var newTime = year + '-' +
                    month + '-' +
                    day + ' ' 

        return newTime;         
    }
}
export default install


// WEBPACK FOOTER //
// ./src/assets/base.js